import { ModalBase } from "../../../../components/Modals/ModalBase";
import "./ModalRetencionesDetectadas.css";

interface ItemRetencionDetectada {
  fechaemision: string;
  serie: string;
  ccf: string;
  receptornombre: string;
  receptornit: string;
  receptornrc: string;
  gravadas: string;
  ivaretenido: string;
}

interface Props {
  items: Array<ItemRetencionDetectada>;
  onClose: () => void;
}

const sumar = (items: Array<ItemRetencionDetectada>, key: 'gravadas' | 'ivaretenido') =>
  items.reduce((total, item) => total + (parseFloat(item[key]) || 0), 0).toFixed(2);

// Detalle (solo lectura) de los CCF con retencion del 1% detectada. La eleccion de incluirlos se hace con el
// checkbox junto al boton "Generar libro de IVA"; nada se guarda hasta generar el libro.
export default function ModalRetencionesDetectadas({ items, onClose }: Props) {
  const totalRetenido = sumar(items, 'ivaretenido');

  return (
    <ModalBase Styles={{ maxWidth: '1100px', width: '96%' }}>
      <div className='modal-card ret-det-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>Previsualización de retenciones del 1%</h3>
          </div>
          <div className='form-separator'></div>
          <div className='ret-det-table-wrap'>
            <table className='ret-det-table'>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Serie</th>
                  <th>CCF</th>
                  <th>Cliente</th>
                  <th>NIT</th>
                  <th>NRC</th>
                  <th className='num'>Gravadas</th>
                  <th className='num'>IVA retenido</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={`${item.serie}-${item.ccf}`}>
                    <td className='nowrap' data-label='Fecha'>{item.fechaemision}</td>
                    <td className='nowrap' data-label='Serie'>{item.serie}</td>
                    <td className='nowrap' data-label='CCF'>{item.ccf}</td>
                    <td className='cliente' data-label='Cliente'>{item.receptornombre}</td>
                    <td className='nowrap' data-label='NIT'>{item.receptornit || '--'}</td>
                    <td className='nowrap' data-label='NRC'>{item.receptornrc || '--'}</td>
                    <td className='num' data-label='Gravadas'>{item.gravadas}</td>
                    <td className='num' data-label='IVA retenido'>{item.ivaretenido}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className='m ret-det-resumen'>
            <b>{items.length}</b> documento(s) · Gravadas: <b>${sumar(items, 'gravadas')}</b> · IVA retenido: <b>${totalRetenido}</b>
          </p>
          <p className='s ret-det-nota'>
            Si los incluye al generar el libro, este se genera como si hubiera cargado el archivo de retenciones. El comprobante
            de retención quedará vacío: deberá completarse con el código de generación de cada comprobante de retención,
            cargando el archivo con esos comprobantes. Mientras tanto, el anexo 7 quedará incompleto.
          </p>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button w-inline-block' onClick={onClose}>
              <div>Cerrar</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  );
}
